// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__QiP5E","centered":"Pagination_centered__YbMPv"};